export class DebitProcessingDates {
   
    DebitProcessingDateFrm: string;
    DebitProcessingDateTo: string;
    Country: string;
}
